import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const AuthRoute = () => {
  const location = useLocation();
  const isAuthenticated = !!localStorage.getItem("access_token");

  // If logged in → go to dashboard
  if (isAuthenticated) {
    return <Navigate to="/dashboard" state={{ from: location }} replace />;
  }

  // If not logged in, allow access to authentication pages.
  return <Outlet />;
};

export default AuthRoute;
